define('plugin/membership/view/MembershipCommonView',['require','lib/view/LayoutView','lib/view/ModalRegion','plugin/membership/view/MembershipCancellationDialogView','view/module/MessageView','lib/plugin/PluginBroker'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ModalRegion = require('lib/view/ModalRegion');
    var MembershipCancellationDialogView = require('plugin/membership/view/MembershipCancellationDialogView');
    var MessageView = require('view/module/MessageView');
    var PluginBroker = require('lib/plugin/PluginBroker');

    /**
     * Membership common view
     *
     * @class MembershipCommonView
     */
    return LayoutView.extend({

        template: '#membership_list_view',
        regions: {
            list: '#sb_membership_list_container',
            filter: '#sb_membership_filter_container',
            status: '#sb_membership_payment_status',
            history: '#sb_membership_history_container',
            pager: '#sb_membership_pager_container'
            
        },
        childEvents: {
            recurringCancel: 'onCancelRecurring'
        },
        type: null,

        initialize: function () {
            var clientModel = PluginBroker.getInstance().getPlugin('client_login').getClientModel();
            if (clientModel) {
                this.listenTo(clientModel, 'sync', this.refreshCollection);
            }
        },

        refreshCollection: function () {
            if (this.getOption('collection')) {
                if (this.getOption('collection').onPagerChanged) {
                    this.getOption('collection').onPagerChanged(); // force load with proper pager params if they exist
                } else {
                    this.getOption('collection').fetch();
                }
            }
        },

        onBeforeShow: function() {
        },

        onCartLoaded: function (model) {
            if (model.get('status') === 'paid' && this.getOption('collection')) {
                this.getOption('collection').fetch();
            }
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this), {
                'type': this.getOption('type')
            });
        },

        onCancelRecurring: function (view, data) {
            var region = new ModalRegion();
            var dialog = new  MembershipCancellationDialogView({
                model: data.model
            });
            region.show(dialog);

            this.listenTo(dialog, 'confirm', this.onCancelRecurringConfirmed);
        },

        onCancelRecurringConfirmed: function (data) {
            this.triggerMethod('onCancel', data.model);
        },

        showErrorMessage: function (error) {
            this.showChildView('status', new MessageView({
                type: 'danger',
                message: error
            }));

            Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
        }

    });

});
